<template>
  <div class="page d-flex">
    <MenuComponent />
    <AppListViewComponent />
  </div>
</template>

<script>
import MenuComponent from "@/components/user/layout/MenuComponent.vue";
import AppListViewComponent from "@/components/user/viewComponent/appList/AppListViewComponent.vue";

export default {
  name: "AppListView",
  components: {
    MenuComponent,
    AppListViewComponent,
  },
};
</script>
